import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const RESET_VISIBLE_VIOLATIONS = 'VISIBLE_VIOLATIONS :: RESET';

export type TResetVisibleViolationsAction = IReduxAction<typeof RESET_VISIBLE_VIOLATIONS>;

export const resetVisibleViolations = actionGenerator<typeof RESET_VISIBLE_VIOLATIONS>(RESET_VISIBLE_VIOLATIONS);
